import { useEffect, useState } from 'react';
import { useContainer } from '../../useContainer';
import { ACSApi } from '../../../api/ACSApi';
import { TimeLogUserSummaryWithUserInfoDto } from '../../../commonTypes/acs/timelog.types';
import { Page } from '../../../commonTypes/pageable.types';
import { toIntDefault0 } from '../../../util/general';

const DEFAULT_STATE: Page<TimeLogUserSummaryWithUserInfoDto> = {
    items: [],
    pageable: { direction: 'asc', page: 1, size: 10 },
    total: '0',
};

const useHttpGetTimeLogSummaryOnMount = (projectId: string, page: number, size: number, from: string, to: string) => {
    const acsApi: ACSApi = useContainer(ACSApi);
    const [isSummaryReady, setIsSummaryReady] = useState<boolean>(false);
    const [summary, setSummary] = useState<Page<TimeLogUserSummaryWithUserInfoDto>>(DEFAULT_STATE);
    const [total, setTotal] = useState<number>(0);

    useEffect(() => {
        setIsSummaryReady(false);
        const { exec, abort } = acsApi.getTimeLogSummary({
            params: { projectId },
            query: { from: encodeURIComponent(from), to: encodeURIComponent(to), page, size },
            onSuccess: res => {
                setSummary(res.body);
                setTotal(toIntDefault0(res.body.total));
            },
            onError: _ => 'Failed to fetch summaries',
            onFinally: () => setIsSummaryReady(true),
        });
        exec();
        return abort;
    }, [projectId, page, size, from, to]);

    return { summary, total, isSummaryReady };
};

export default useHttpGetTimeLogSummaryOnMount;
